export const OptimizableField = {
  TITLE: 'title',
  BULLETS: 'bullets',
  DESCRIPTION: 'description'
} as const;
export type OptimizableFieldType = (typeof OptimizableField)[keyof typeof OptimizableField];

export interface FieldSuggestion {
  suggestion: string;
  reasoning: string;
}

export interface OptimizationResult {
  title: FieldSuggestion | null;
  bullets: FieldSuggestion | null;
  description: FieldSuggestion | null;
  alexaScore: number | null;
}

/**
 * Stable id for each row of `CATEGORY_MAP` (ai-optimize-utils.ts), so callers can
 * reason about which title formula a product resolved to without re-running the
 * regexes — and so the routing itself is unit-testable.
 */
export const CategoryFormulaKey = {
  WATCHES: 'watches',
  CONSUMER: 'consumer',
  HARDLINES: 'hardlines',
  APPAREL: 'apparel',
  /** Nothing matched — `CATEGORY_FALLBACK` supplied the emphasis. */
  FALLBACK: 'fallback'
} as const;
export type CategoryFormulaKeyType = (typeof CategoryFormulaKey)[keyof typeof CategoryFormulaKey];

export const OptimizeBand = {
  PRIORITY: 'priority',
  STANDARD: 'standard',
  POLISH: 'polish',
  OPTIMIZED: 'optimized'
} as const;
export type OptimizeBandType = (typeof OptimizeBand)[keyof typeof OptimizeBand];

export const FIELD_LABEL: Record<OptimizableFieldType, string> = {
  [OptimizableField.TITLE]: 'Product Title',
  [OptimizableField.BULLETS]: 'Feature Bullets',
  [OptimizableField.DESCRIPTION]: 'Long Description'
};

export const FIELD_WEIGHT: Record<OptimizableFieldType, number> = {
  [OptimizableField.TITLE]: 25,
  [OptimizableField.BULLETS]: 15,
  [OptimizableField.DESCRIPTION]: 5
};
